import { categories } from '@/mocks/homepage';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-xs font-semibold text-foreground-600 mb-5 whitespace-nowrap">
            吃瓜分类
          </span>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-4">
            <strong>四大专区</strong> / 精准吃瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            覆盖网红、明星、社会、娱乐圈，全网独家资源一站式聚合
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={`/category/${cat.slug}`}
              className="group block p-7 md:p-8 rounded-xl bg-background-100 transition-all duration-300 hover:bg-primary-500"
              title={`进入${cat.title}专区`}
            >
              <div className="w-12 h-12 rounded-xl bg-background-200 flex items-center justify-center mb-5 group-hover:bg-background-50/20 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 group-hover:text-background-50 transition-colors mb-3">
                {cat.title}
              </h3>
              <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed mb-5">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 group-hover:text-background-50 transition-colors whitespace-nowrap">
                进入专区
                <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform inline-block"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}